import { selectedOrderSlice } from './selected-order/selected-order.slice';

type OrderActions = typeof selectedOrderSlice.actions;

// Exporting all actions from slices in one file mimics exported variables from a context and encourages more explicit naming
const { setSelectedOrder, clearSelectedOrder } = selectedOrderSlice.actions;

export const orderActions: OrderActions = {
  // Selected order actions
  setSelectedOrder,
  clearSelectedOrder,
};
